import { render, staticRenderFns } from "./XlsxQuizUploader.vue?vue&type=template&id=ce191910&scoped=true&"
import script from "./XlsxQuizUploader.vue?vue&type=script&lang=js&"
export * from "./XlsxQuizUploader.vue?vue&type=script&lang=js&"
import style0 from "./XlsxQuizUploader.vue?vue&type=style&index=0&id=ce191910&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce191910",
  null
  
)

export default component.exports